<template>
	<div class="login">
		<div class="loginWrapper">
			<!-- <div class="loginImage" /> -->

			<div class="loginFormWrapper">
				<img alt="logo" v-if="this.$store.state.logo == 'bd'" src="../assets/bdlogo-color.png" class="login-logo" />
				<img alt="logo" v-if="this.$store.state.logo == 'tbs'" src="../assets/tbs-logo.jpg" class="login-tbs-logo" />
				<img alt="logo" v-if="this.$store.state.logo == 'nrm'" src="../assets/nrm-logo.png" class="login-logo" />

				<div class="loginForm">
					<input name="username" class="textInput" placeholder="username" v-model="username" v-on:keyup.enter="submit" />

					<br />

					<input class="textInput" placeholder="password" type="password" v-model="password" v-on:keyup.enter="submit" />

					<button @click.prevent="submit" class="loginButton">Login</button>
				</div>
			</div>
		</div>
		<p class="credit">
			Designed and Developed by Zino Tech
		</p>
	</div>
</template>

<script>
export default {
	name: 'Login',
	data: function() {
		return {
			username: null,
			password: null
		}
	},
	mounted: function() {
		if (this.$store.state.auth) {
			this.$router.push('sales')
		}
	},
	methods: {
		submit: async function() {
			if (this.username === null || this.password === null) {
				this.$buefy.toast.open({
					message: 'Both fields are required',
					type: 'is-danger',
					position: 'is-top'
				})
			} else {
				this.userLogin()
			}
		},
		userLogin: async function() {
			const userLogin = await this.$api.login({
				username: this.username,
				password: this.password
			})

			if (userLogin) {
				this.$buefy.toast.open({
					message: 'Login Successful!',
					type: 'is-success',
					position: 'is-top'
				})

				this.$axios.defaults.headers.common['Authorization'] = 'Token ' + userLogin.data.staffs_authToken

				// Save in x
				this.$store.dispatch('set_auth', userLogin.data.staffs_authToken)

				this.$router.push('sales')
			}
		}
	},
	computed: {
		userInfo: function() {
			return `Username: ${this.username} & Password: ${this.password}`
		}
	}
	// watch: {
	//   username: function(newData, oldData) {
	//     console.log(newData, oldData);
	//   }
	// }
}
</script>

<style scoped>
@import '../styles/Login.css';
</style>
